module.exports={CapabilitiesAffected:"受影响的功能:",ShowRelated:"显示 {relatedCount} 个相关项"};